import React, { Component } from 'react';
import { Menu } from 'semantic-ui-react';
import { BrowserRouter as Router, Route, Switch, Link, NavLink } from 'react-router-dom';

class MenuBar extends Component {
    state = { activeItem: 'home' }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    render() {
        const { activeItem } = this.state

        return (
            <div>
            <Menu pointing>
                

            <Menu.Item 
                as={Link}
                to="/notice"
                name='notice' 
                active={activeItem === 'notice'} 
                onClick={this.handleItemClick}>
                    General Notice
        </Menu.Item>


        <Menu.Item 
                as={Link}
                to="/tender"
                name='tender' 
                active={activeItem === 'tender'} 
                onClick={this.handleItemClick}>
                    General Tender
        </Menu.Item>
                

                <Menu.Item
                    as={Link}
                    to="/news"
                    name='news'
                    active={activeItem === 'news'}
                    onClick={this.handleItemClick}
                >
                    News
        </Menu.Item>
                <Menu.Item
                    as={Link}
                    to="/events"
                    name='events'
                    active={activeItem === 'events'}
                    onClick={this.handleItemClick}
                >
                    Events
        </Menu.Item>

                {/* <Menu.Item
                    name='flash'
                    active={activeItem === 'flash'}
                    onClick={this.handleItemClick}
                >
                    Flash Notifications
        </Menu.Item>

                <Menu.Item
                    name='pushnotifications'
                    active={activeItem === 'pushnotifications'}
                    onClick={this.handleItemClick}
                >
                    Push Notifications
        </Menu.Item> */}
            </Menu>
            </div>
        )
    }
}

export default MenuBar;


// WEBPACK FOOTER //
// ./src/HomeComponents/HeaderComponents/MenuBar.js